export function sanitizeName(name) {
  if (!name) return '';
  const str = String(name);

  return str
    .replace(/["'`*\\;<>|[\]{}()^%$#@!~?=]/g, '')
    .trim();
}


export function sanitizeEmail(email) {
  if (typeof email !== 'string') return '';
  return email.toLowerCase().replace(/["'`]/g, '');
}
